/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { attributes } from '../../data/attributes';
import { getSports } from '../../data/sports';
import SelectCardAttribute from './SelectCardAttribute';

export default function SelectAttribute(): JSX.Element {
    const listAttributes = attributes();
    const sport = getSports();
    return (
        <div
            className={`relative flex z-20 justify-center items-center pt-1 mb:pt-5 lg:pb-16 lg:pt-16 mb:pb-16 mb:pt-16 px-0`}
        >
            <section
                className={`grid w-full md:w-auto px-1 md:px-0  grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2`}
            >
                {listAttributes &&
                    listAttributes.length > 0 &&
                    listAttributes.map((s) => <SelectCardAttribute urlSport={sport.url} key={s.title} attribute={s} />)}
            </section>
        </div>
    );
}
